// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2g2Kq","content":"LayoutSettings_content__UIpx5"};